export class Location {
  constructor(
    public id?: number,
    public address?: string,
    public altitude?: number,
    public latitude?: number,
    public longitude?: number
  ) {}
}
